import { defineStore } from 'pinia';
import { createOrUpdateCollectionRequest, getCollectionRequestByUserId, 
  confirmCollectionRequest, 
  type CRequestFilterRequest, getCollectionRequests, getCollectionRequestById, 
  updateDesiredCollectionDate, updateRegisterdCollectionDate, 
  deleteCollectionDate, type CollectionDateVerification, verifyCollectionDate,
  getCollectionRequestsForTrans,
  getProjectsForCollectionRequest,
  getProjectContractRange,
  getNotCollectedDates,
  getRecentCollectedRequestsByProjectId as getRecentCollectedRequestsByProjectIdService,
  type RecentCollectedRequestResponse,
    registerCollectionRequests,
    printCollectionRequests,
 } from '@/services/modules/crequest';
import type { ExpectedDateTimeValidation } from '@/views/CollectionRequest/const';
import type { CollectionDates, CollectionScheduleDetail } from '@/views/CollectionSchedule/const';
import type { Project } from '@/views/CollectionRequest/const';

export const useCrequestStore = defineStore({
  id: 'crequest',
  state: () => ({
    collectionRequestById:{} as CollectionScheduleDetail,
    collectionRequest: {} as any,
    collectionRequests:[] as any,
    collectionRequestsForTrans:[] as any,
    collectionRequestsForAdmin:[] as any,
    cRProjects:[] as Project[],
    contractRangeByProject:[] as any,
    filters :[] as any,
    notCollectedDates:[] as any,
    recentCollectedRequests: [] as RecentCollectedRequestResponse[],
    selectedProjectId:'',
    canShowCollectionRequest: true,
    // List view UI state for CollectionSchedule
    listSwitchState: { bulkRegistrationMode: false, deliveryConfirmationMode: false } as { bulkRegistrationMode: boolean; deliveryConfirmationMode: boolean },
    listCheckedIds: [] as number[],
    shouldRestoreListState: false as boolean,
  }),
  getters: {
    isRequestEmpty: (state) => Object.keys(state.collectionRequest).length === 0,
  },
  persist: {
    paths: ['canShowCollectionRequest']
  },
  actions: {
    setSelectedProjectId(projectId: string) {
      this.selectedProjectId = projectId
    },

    async createOrUpdateCollectionRequest(crequest: any) {
      try {
        await createOrUpdateCollectionRequest(crequest);
      } catch (error) {
        console.error('Error creating or updating collection request:', error);
      }
    },
    
    async getCollectionRequestByUserId() {
      try {
        const response:any = await getCollectionRequestByUserId();
        this.collectionRequest = response.data;
        return response;
      } catch (error) {
        return error
      }
    },

    async getRecentCollectedRequestsByProjectId(projectId: string) {
      try {
        const response = await getRecentCollectedRequestsByProjectIdService(projectId);
        this.recentCollectedRequests = response as unknown as RecentCollectedRequestResponse[];
        return response;
      } catch (error) {
        return error;
      }
    },

    async getProjectContractRange(projectId: String) {
      try {
        const response = await getProjectContractRange(projectId);
        this.contractRangeByProject = response;
        return response;
      } catch (error) {
        return error
      }
    },
    
    async confirmCollectionRequest(crequestId: number) {
      try {
        await confirmCollectionRequest(crequestId);
      } catch (error) {
        console.error(`Error confirming collection request ID ${crequestId}:`, error);
      }
    },

    async getCollectionRequests(crequestFilters: CRequestFilterRequest[]){
      try {
        const response = await getCollectionRequests(crequestFilters);
        this.collectionRequests = response;
      } catch (error) {
        console.error(`Error getting collection requests:`, error);
      }
    },

    async getProjectsForCollectionRequest(){
      try {
        const response = await getProjectsForCollectionRequest();
        this.cRProjects = response as any;
      } catch (error) {
        console.error(`Error getting collection requests:`, error);
      }
    },
    
    async getCollectionRequestsForTrans(crequestFilters: CRequestFilterRequest[],companyId:number){
      try {
        const response = await getCollectionRequestsForTrans(crequestFilters,companyId);
        this.collectionRequests = response;
      } catch (error) {
        console.error(`Error getting collection requests:`, error);
      }
    },

    async getCollectionRequestById(crequestId:number){
        const response = await getCollectionRequestById(crequestId);
        this.collectionRequestById = response as CollectionScheduleDetail;
        return response;
    },

    async getNotCollectedDates() {
      try {
        const response = await getNotCollectedDates();
        this.notCollectedDates = response;
      } catch (error) {
        console.error(`Error getting not collected dates:`, error);
      }
    }
    ,

    async updateDesiredCollectionDate(crequestId: number,dates:CollectionDates) {
      try {
        await updateDesiredCollectionDate(crequestId,dates);
      } catch (error) {
        console.error(`Error updating desired collection date:`, error);
      }
    },

    async updateRegisterdCollectionDate(crequestId: number,dates:CollectionDates) {
      try {
        await updateRegisterdCollectionDate(crequestId,dates);
      } catch (error) {
        console.error(`Error updating registered collection date:`, error);
      }
    },

    async deleteCollectionDate(crequestId: number,shouldProcessAll: boolean) {
      await deleteCollectionDate(crequestId,shouldProcessAll);
    },

    async verifyCollectionDate(collectionDateVerification:CollectionDateVerification){
      try {
        return await verifyCollectionDate(collectionDateVerification);
      } catch (error) {
        console.error(`Error verifying collection date:`, error);
      }
    },

      async registerCollectionRequests(requestData: any) {
          try {
              return await registerCollectionRequests(requestData);
          } catch (error) {
              console.error('Error registering collection requests:', error);
          }
      },

      async printCollectionRequests(printData: any) {
          try {
              return await printCollectionRequests(printData);
          } catch (error) {
              console.error('Error printing collection requests:', error);
          }
    }
  },
});
